<template>
    <div class="flex flex-col md:flex-row gap-4">
        <div
            class="flex-1 border-solid rounded-xl border-t-20 border-lightblue bg-grey p-6 flex flex-col items-center gap-3"
        >
            <img src="@/assets/img/graphics/common/antibody.svg" alt="Antibody icon" class="mt-2" />

            <h5 class="text-2xl text-center mt-1">Serologies</h5>

            <p class=" font-light self-start mt-8">The following serologies were normal or negative:</p>
            <ul class="list-disc pl-4 font-light self-start">
                <li>Anti-nuclear antibody panel</li>
                <li>Rheumatoid factor</li>
                <li>C3 and C4 complements</li>
                <li>Cryoglobulins</li>
                <li>ANCA</li>
                <li>Anti-GBM</li>
                <li>Anti-streptolysin O titer</li>
                <li>HIV antigen and antibody</li>
                <li>Hepatitis C</li>
                <li>Syphilis</li>
                <li>Hepatitis B surface antigen</li>
                <li>Hepatitis B surface antibodies revealed immunity</li>
                <li>Serum protein electrophoresis showed no monoclonal gammopathy</li>
                <li>Serum Ig free light chain κ/λ ratio <br />was 2.83</li>
            </ul>
        </div>

        <div
            class="flex-1 border-solid rounded-xl border-t-20 border-maroon bg-grey p-6 flex flex-col items-center gap-3"
        >
            <img src="@/assets/img/graphics/eskd/kidneys-maroon.svg" alt="Kidneys icon" class="h-14 mt-4" />

            <h5 class="text-2xl text-center">Urinalysis, urine cultures, and blood cultures</h5>

            <ul class="list-disc pl-4 font-light self-start">
                <li>Urine cultures grew multidrug-sensitive <span class="italic">Escherichia coli</span></li>
                <li>Blood cultures showed no growth</li>
                <li>COVID-19 nasopharyngeal swab PCR was negative</li>
            </ul>
        </div>

        <div
            class="flex-1 border-solid rounded-xl border-t-20 border-purple bg-grey p-6 flex flex-col items-center gap-3"
        >
            <img src="@/assets/img/graphics/eskd/thrombosis-purple.svg" alt="Thrombosis icon" class="mt-3" />

            <h5 class="text-2xl text-center">Thrombosis workup</h5>

            <p class=" font-light self-start mt-8">
                Thrombosis workup, to investigate potential blood clot, was negative; this included:
            </p>
            <ul class="list-disc pl-4 font-light self-start">
                <li>Protein C activity</li>
                <li>Protein S levels</li>
                <li>Anti-thrombin levels</li>
                <li>Factor V Leiden levels</li>
                <li>Lupus anticoagulant ratio</li>
                <li>Anti-cardiolipin IgG antibody</li>
            </ul>
        </div>
    </div>
</template>
